import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HhsgSharedConfigService} from "../services";

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// XSRF Config:
// Here we set the X-XSRF-TOKEN header on mutating requests. The server will look for the header when a Request comes in.
// The X-XSRF-TOKEN header value comes from a cookie received from the server on the initial request made in the app.component.
// Turning on withCredentials when we make that first request to the initXsrf endpoint allows for the xsrf cookie to be set.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// General XSRF Info:
// 0. The xsrf token should be static changing as few times as possible in a session. Note: Page refresh will update it - that's okay.
// 1. The server code in startup.cs - extension UseXsrfCookie() adds the XSRF cookie ONCE on initial request.
// 2. The server code in startup.cs - extension AddXsrfValidation() sets the header for XSRF to look for from a Request and enables XSRF checks.
//
// 3a. The UI uses calls the XsrfService from app.component to set WithCredentials true on initial request allowing the xsrf cookie to be set ONCE.
// 3b. The UI uses this custom HTTPInterceptor to set the header X-XSRF-TOKEN on POST requests for validation by the server.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  private readonly _skipMethods = ['GET', 'HEAD'];
  private static readonly XsrfHeaderName = 'X-XSRF-TOKEN';

  constructor(
    private tokenExtractor: HttpXsrfTokenExtractor,
    private _configService: HhsgSharedConfigService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldAddXsrfToken(req)) {
      req = req.clone({
        headers: this.addXsrfToken(req),
        withCredentials: true
      });
    }

    return next.handle(req);
  }

  private shouldAddXsrfToken(req: HttpRequest<any>) {
    return req.url.toLowerCase().includes(this._configService.appSettings.webApiServer) && !this._skipMethods.includes(req.method);
  }

  private addXsrfToken(req: HttpRequest<any>) {
    let xsrfToken = this.tokenExtractor.getToken();
    return xsrfToken ? req.headers.set(XsrfInterceptor.XsrfHeaderName, xsrfToken) : req.headers;
  }
}
